type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export const AccountMode = {
  Personal: 'personal',
  Professional: 'professional',
} as const;
Object.freeze(AccountMode);

export type AccountModeValue = (typeof AccountMode)[keyof typeof AccountMode];

export type SettingsState = {
  mode?: AccountModeValue | string;
};

const defaultValue: SettingsState = {
  mode: AccountMode.Personal,
};

const initialState: SettingsState = defaultValue;

const settingsReducer = (
  state: SettingsState = initialState,
  action: ReducerAction
): SettingsState => {
  switch (action.type) {
    case 'AUTH_LOGOUT':
    case 'AUTH_LOGOUT_SUCCESS': {
      return {};
    }
    case 'SETTINGS_UPDATE_MODE': {
      let mode = action.mode || AccountMode.Personal;
      if (mode !== AccountMode.Professional) {
        mode = AccountMode.Personal;
      }
      return {
        // ...state,
        mode,
      };
    }
    default:
      return state;
  }
};
export default settingsReducer;
